import { TRAINING_START_WORKOUT_DOMAIN } from 'modules/training/modules/training-start-workout/constants'

export function getStartWorkoutSelector () {
  return (state) => {
    return state[TRAINING_START_WORKOUT_DOMAIN]
  }
}
